'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("DocumentEcheanceEditionPopinController", function ($scope, $dateFormat) {
  var originalDocument = $scope.document;
  $scope.document = angular.copy(originalDocument);
  $scope.document.type = 'AVIS_ECHEANCE'; // par défaut
  if (!$scope.document.tags) {
    $scope.document.tags = {};
  }
  $scope.document.tags.DATE_ECHEANCE = $dateFormat.serverShort($scope.dateEcheance);
  $scope.errors = {};
  $scope.saveAndClose = function () {
    $scope.errors.label = $scope.document.label ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.type = $scope.document.type ? undefined : {
      message: "Champ obligatoire"
    };
    $scope.errors.url = !$scope.document.externe || $scope.document.url ? undefined : {
      message: "Champ obligatoire"
    };
    if (!$scope.errors.label && !$scope.errors.type && !$scope.errors.url) {
      _.extend(originalDocument, $scope.document);
      $scope.$close(originalDocument);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/documents/documentEcheanceEditionPopin.js
// module id = 2772
// module chunks = 13